import React from 'react';
import {useHistory} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import {Button} from "@material-ui/core";
import Loading from "../../../Loading";

const useStyle = makeStyles((theme) => ({
    button: {
        backgroundColor: "#BB0D66",
        color: "#fff",
        width: "150px",
        "&:hover": {
            backgroundColor: "#8a0046"
        }
    },
    text: {
        fontSize: "24px",
        marginBottom: "48px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center"
    }
}))

function NewAffinitySuccess(props) {
    const history = useHistory();
    const classes = useStyle();
    const edit = props.edit;

    const clickHandler = () => {
        history.push('/u/m/dashboard')
    }

    const title = (isEdit) => {
        if (isEdit)
            return "La afinidad fue editada exitosamente"
        else
            return "La afinidad fue cargada y asignada exitosamente"

    }

    return (
        <React.Fragment>
            {!props.loading ?
                <>
                    <h3 className={classes.text}>{title(edit)}</h3>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "center"}}><Button
                        variant="contained"
                        onClick={clickHandler}
                        className={classes.button}
                    >
                        Finalizar
                    </Button></div>

                </>
                :
                <Loading/>
            }
        </React.Fragment>
    );
}

export default NewAffinitySuccess;